export default __webpack_public_path__ + "static/media/LorenaCardenasRev2.6809c6e1.pdf";